enum FulfilmentMethod {
  AS_SOON_AS_POSSIBLE = "as-soon-as-possible",
  ON_DEMAND = "on-demand",
  AUTOMATIC = "automatic"
}

export default FulfilmentMethod;
